import { render } from "./LedgerReport.vue?vue&type=template&id=19e3b9e2&scoped=true"
import script from "./LedgerReport.vue?vue&type=script&lang=js"
export * from "./LedgerReport.vue?vue&type=script&lang=js"

import "./LedgerReport.vue?vue&type=style&index=0&id=19e3b9e2&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e3b9e2"]])

export default __exports__